const Report = () =>
  import(
    /* webpackChunkName: "user-session" */ '@/pages/user/session/index.vue'
  )

export default {
  path: 'session',
  meta: {
    label: 'userSession',
    auth: 'session'
  },
  component: {
    name: 'Session',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'UserSessionReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    }
  ]
}
